import { type ReleaseNotes, createReleaseNotes } from 'models';
import { useInfiniteQuery } from 'query';
import type { PaginationData } from 'common/services';
import type { ReleaseNotesDataObject } from 'models/service';
import { getReleaseNotes } from '../services';
import { getReleaseNotesQueryKey } from './keys';

export const useReleaseNotesQuery = ({ limit }: { limit: number }) =>
  useInfiniteQuery<PaginationData<ReleaseNotes>, number>({
    async queryFn({ pageParam }) {
      const { data: releaseNotes } = await getReleaseNotes({
        $limit: limit,
        $skip: pageParam,
        platform: 'fe',
      });

      return {
        data: releaseNotes.data.map((releaseNote: ReleaseNotesDataObject) => createReleaseNotes(releaseNote)),
        limit: releaseNotes.limit,
        skip: releaseNotes.skip,
        total: releaseNotes.total,
      };
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage) =>
      lastPage.skip + lastPage.data.length < lastPage.total ? lastPage.skip + lastPage.limit : undefined,
    queryKey: getReleaseNotesQueryKey({ limit }),
  });
